// import React from 'react';
// import {
//   FormControl,
//   Typography,
//   Select,
//   MenuItem,
//   OutlinedInput,
//   FormHelperText,
//   InputAdornment
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Custom icon
// import palette from 'src/theme/palette';
// import ErrorIcon from '@mui/icons-material/Error';

// const CustomDropdown = ({
//   label = '',
//   value,
//   options = [],
//   onChange,
//   placeholder = '',
//   sx = {},
//   name,
//   error = false,
//   helperText = '',
//   onBlur,
//   fontFamily,
//   backgroundColor,
//   marginBottom,
//   fontSize,
//   height,
//   width,
//   disabled,
//   sxMain,
//   titleSx,
//   labelFontMedium
// }) => {
//   return (
//     <FormControl
//       fullWidth
//       size="small"
//       sx={{ marginBottom: error ? '0.2rem' : marginBottom || '1rem', ...sxMain }}
//       error={error}
//     >
//       {label && (
//         <Typography
//           sx={{
//             ...titleSx,
//             fontSize: 12,
//             marginBottom: '4px',
//             fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
//             color: '#1a1a1a'
//           }}
//         >
//           {label}
//         </Typography>
//       )}

//       <Select
//         disabled={disabled}
//         name={name}
//         value={value}
//         fullWidth
//         onChange={onChange}
//         onBlur={onBlur}
//         displayEmpty
//         variant="outlined"
//         IconComponent={ExpandMoreIcon}
//         input={
//           <OutlinedInput
//             error={error} // ✅ forward error so red border shows
//             endAdornment={
//               error && (
//                 <InputAdornment position="end" sx={{ marginRight: 2 }}>
//                   <ErrorIcon color="warning " sx={{ fontSize: 20, color: 'red' }} />
//                 </InputAdornment>
//               )
//             }
//           />
//         }
//         sx={{
//           borderRadius: '6px',
//           fontSize: fontSize || 12,
//           fontFamily: fontFamily || 'poppinsRegular',
//           color: palette.primary.titledark,
//           height: height || 40,
//           width,
//           backgroundColor: backgroundColor || 'transparent',
//           '& .MuiOutlinedInput-notchedOutline': {
//             borderColor: error ? palette.error.main : palette.primary.inputborder, // ✅ dynamic border color
//             borderWidth: '1.5px'
//           },
//           '&:hover .MuiOutlinedInput-notchedOutline': {
//             borderColor: error ? palette.error.main : palette.primary.inputborder
//           },
//           '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//             borderColor: error ? palette.error.main : palette.primary.inputborder,
//             borderWidth: '1.5px'
//           },
//           '& .MuiSvgIcon-root': {
//             color: error ? palette.primary.deleteButtonTitle : palette.primary.dropdownArrow,
//             fontSize: 18
//           },
//           ...sx
//         }}
//         MenuProps={{
//           PaperProps: {
//             sx: {
//               backgroundColor: '#fff',
//               color: '#1A202C',
//               borderRadius: 1,
//               fontSize: 12
//             }
//           }
//         }}
//       >
//         {options.map((option, index) => (
//           <MenuItem key={index} value={option.value} sx={{ fontSize: 12 }}>
//             {option.label}
//           </MenuItem>
//         ))}
//       </Select>
//       {helperText && (
//         <FormHelperText sx={{ ml: 0, mb: 0, fontSize: 11, fontFamily: 'poppinsRegular' }}>
//           {helperText}
//         </FormHelperText>
//       )}
//     </FormControl>
//   );
// };

// export default CustomDropdown;

import React from 'react';
import { FormControl, Typography, TextField, FormHelperText, InputAdornment } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorIcon from '@mui/icons-material/Error';
import Autocomplete from '@mui/material/Autocomplete';
import palette from 'src/theme/palette';

const CustomAutocomplete = ({
  label = '',
  value,
  options = [],
  onChange,
  placeholder = '',
  sx = {},
  name,
  error = false,
  helperText = '',
  onBlur,
  fontFamily,
  backgroundColor,
  marginBottom,
  fontSize,
  height,
  width,
  disabled,
  sxMain,
  titleSx,
  labelFontMedium
}) => {
  return (
    <FormControl
      fullWidth
      size="small"
      sx={{ marginBottom: error ? '0.2rem' : marginBottom || '1rem', ...sxMain }}
      error={error}
    >
      {label && (
        <Typography
          sx={{
            ...titleSx,
            fontSize: 12,
            marginBottom: '4px',
            fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
            color: '#1a1a1a'
          }}
        >
          {label}
        </Typography>
      )}

      <Autocomplete
        disableClearable
        disabled={disabled}
        options={options}
        value={options.find((opt) => opt.value == value) || null}
        onChange={(event, newValue) => onChange({ target: { name, value: newValue?.value || '' } })}
        onBlur={onBlur}
        getOptionLabel={(option) => option.label || ''}
        popupIcon={<ExpandMoreIcon />}
        ListboxProps={{
          sx: {
            fontSize: 12 // ✅ yahan control kar le
          }
        }}
        filterOptions={(options, state) => {
          const input = state.inputValue.toLowerCase();

          // prefix matches (jo input se start hote hain)
          const startsWithMatches = options.filter((o) =>
            o?.label?.toLowerCase()?.startsWith(input)
          );

          // substring matches (jo input me kahi bhi hain, lekin start nahi hote)
          const substringMatches = options.filter(
            (o) =>
              o?.label?.toLowerCase()?.includes(input) &&
              !o?.label?.toLowerCase()?.startsWith(input)
          );

          return [...startsWithMatches, ...substringMatches]; // prefix upar, baaki neeche
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            fontSize: fontSize || 12,
            fontFamily: fontFamily || 'poppinsRegular',
            color: palette.primary.titledark,
            height: height || 40,
            width,
            backgroundColor: backgroundColor || 'transparent',
            '& fieldset': {
              borderColor: error ? palette.error.main : palette.primary.inputborder,
              borderWidth: '1.5px'
            },
            '&:hover fieldset': {
              borderColor: error ? palette.error.main : palette.primary.inputborder
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? palette.error.main : palette.primary.inputborder,
              borderWidth: '1.5px'
            }
          },
          '& .MuiSvgIcon-root': {
            color: error ? palette.primary.deleteButtonTitle : palette.primary.dropdownArrow,
            fontSize: 18
          },
          ...sx
        }}
        componentsProps={{
          paper: {
            sx: {
              '& .MuiAutocomplete-noOptions': {
                fontSize: 12,
                fontFamily: 'poppinsRegular',
                color: '#999', // halka grey
                padding: '14px 10px'
              }
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            placeholder={placeholder}
            error={error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {error && (
                    <InputAdornment position="end" sx={{ marginRight: 0 }}>
                      <ErrorIcon color="error" sx={{ fontSize: 20 }} />
                    </InputAdornment>
                  )}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />

      {helperText && (
        <FormHelperText sx={{ ml: 0, mb: 0, fontSize: 11, fontFamily: 'poppinsRegular' }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomAutocomplete;
